var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6264_4027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 2.96924C6.5 3.36706 6.65804 3.74859 6.93934 4.0299C7.22064 4.3112 7.60218 4.46924 8 4.46924C8.39782 4.46924 8.77936 4.3112 9.06066 4.0299C9.34196 3.74859 9.5 3.36706 9.5 2.96924C9.5 2.57141 9.34196 2.18988 9.06066 1.90858C8.77936 1.62727 8.39782 1.46924 8 1.46924C7.60218 1.46924 7.22064 1.62727 6.93934 1.90858C6.65804 2.18988 6.5 2.57141 6.5 2.96924V2.96924Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 14.9692C6.5 15.3671 6.65804 15.7486 6.93934 16.0299C7.22064 16.3112 7.60218 16.4692 8 16.4692C8.39782 16.4692 8.77936 16.3112 9.06066 16.0299C9.34196 15.7486 9.5 15.3671 9.5 14.9692C9.5 14.5714 9.34196 14.1899 9.06066 13.9086C8.77936 13.6273 8.39782 13.4692 8 13.4692C7.60218 13.4692 7.22064 13.6273 6.93934 13.9086C6.65804 14.1899 6.5 14.5714 6.5 14.9692Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 14.9692C1 15.3671 1.15804 15.7486 1.43934 16.0299C1.72064 16.3112 2.10218 16.4692 2.5 16.4692C2.89782 16.4692 3.27936 16.3112 3.56066 16.0299C3.84196 15.7486 4 15.3671 4 14.9692C4 14.5714 3.84196 14.1899 3.56066 13.9086C3.27936 13.6273 2.89782 13.4692 2.5 13.4692C2.10218 13.4692 1.72064 13.6273 1.43934 13.9086C1.15804 14.1899 1 14.5714 1 14.9692V14.9692Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.9692C12 15.3671 12.158 15.7486 12.4393 16.0299C12.7206 16.3112 13.1022 16.4692 13.5 16.4692C13.8978 16.4692 14.2794 16.3112 14.5607 16.0299C14.842 15.7486 15 15.3671 15 14.9692C15 14.5714 14.842 14.1899 14.5607 13.9086C14.2794 13.6273 13.8978 13.4692 13.5 13.4692C13.1022 13.4692 12.7206 13.6273 12.4393 13.9086C12.158 14.1899 12 14.5714 12 14.9692Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13.4692C2.5 12.4084 2.92143 11.391 3.67157 10.6408C4.42172 9.89067 5.43913 9.46924 6.5 9.46924H9.5C10.5609 9.46924 11.5783 9.89067 12.3284 10.6408C13.0786 11.391 13.5 12.4084 13.5 13.4692",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4.46924V13.4692",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6264_4027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.970703)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModules);
export default __webpack_public_path__ + "static/media/modules.35643f7a.svg";
export { ForwardRef as ReactComponent };